'use strict'
import defapp from './defapp'

export default class utilfunc { 

    getExtension(ext)
    {
        
        if (ext == 'jpg' || ext == 'png' || ext == 'jpeg' || ext == 'svg') { 
            return defapp.TYPE_ATTACH_IMAGE
        }

        if(ext == 'wav' || ext == 'mp4')
        {
            return defapp.TYPE_ATTACH_AUDIO
        }

        return defapp.TYPE_ATTACH_OTHER
    }
}